module.exports = __webpack_public_path__ + "static/media/B_classic_bronze.43053659.png";